import React, { FunctionComponent, useMemo, useState } from "react";
import { Boolean, DataTableDef, SelectionMode } from "@plex/react-components";
import { getSchemasInUse, listSchemas } from "../NodeTypes/DataSchemas";
import { IViewController, useViewController } from "../ViewContext";
import { useReactFlow } from "reactflow";
import { IDocumentSchema } from "../FlowDocument/FlowDocumentModel";

export interface IUserDefinedSchemasGridProps {
  onSelectionChanged?: (row: IUserDefinedSchemaGridRow | undefined) => void;
}

interface IUserDefinedSchemaGridRow {
  id: string;
  name: string;
  inUse: boolean;
}

export const UserDefinedSchemasGrid: FunctionComponent<IUserDefinedSchemasGridProps> = (props) => {
  const [selected, setSelected] = useState<IUserDefinedSchemaGridRow[]>([]);
  const [gridDataState, setGridDataState] = useState<IUserDefinedSchemaGridRow[]>([]);
  const reactFlowInstance = useReactFlow();
  const { experimentalModeState, flowInputController }: IViewController = useViewController();

  useMemo(() => {
    const schemasInUse = getSchemasInUse(
      experimentalModeState,
      flowInputController?.flowInputPool,
      reactFlowInstance,
      true
    );
    setGridDataState(
      listSchemas({ userDefinedOnly: true, includeLists: false }).map((schema) => ({
        id: schema.id,
        name: schema.name,
        inUse: schemasInUse.some((schemaInUse: IDocumentSchema) => schemaInUse.id === schema.id)
      }))
    );
  }, [
    experimentalModeState,
    flowInputController,
    reactFlowInstance,
    JSON.stringify(listSchemas({ userDefinedOnly: true, includeLists: false }))
  ]);

  return (
    <DataTableDef<IUserDefinedSchemaGridRow>
      data={gridDataState}
      keySelector={(row: IUserDefinedSchemaGridRow) => row.id}
      selectionMode={SelectionMode.single}
      className="user-defined-schemas-editor-grid"
      emptyText="No records were found."
      selected={selected}
      onSelectionChanged={(selectedRows: IUserDefinedSchemaGridRow[]) => {
        setSelected(selectedRows);
        props.onSelectionChanged?.(selectedRows.length > 0 ? selectedRows[0]! : undefined);
      }}
    >
      <DataTableDef.Column<IUserDefinedSchemaGridRow> id="1" title="Name" sortable>
        {(row: IUserDefinedSchemaGridRow) => row.name}
      </DataTableDef.Column>
      <DataTableDef.Column<IUserDefinedSchemaGridRow> id="2" title="In Use">
        {(row: IUserDefinedSchemaGridRow) => <Boolean value={row.inUse} />}
      </DataTableDef.Column>
    </DataTableDef>
  );
};
